import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom"; // Import useNavigate
import "../css/NavBar.css";
import { FaUserCircle, FaTimes, FaSearch } from "react-icons/fa";
import SearchBar from "./SearchBar";
import EmailModal from "./EmailModal"; // adjust path if needed


const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false); // New state for toggling search

  const userIconRef = useRef(null);

  const toggleSearch = () => {
    setIsSearchActive((prevState) => !prevState); // Toggle search state
    setIsSidebarOpen(false); // Ensure sidebar closes if open 
  };

  useEffect(() => {
    if (isSidebarOpen || isSearchActive) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [isSidebarOpen, isSearchActive]);

  return (
    <>
      <div className={`overlay ${isSearchActive || isSidebarOpen ? 'open' : ''}`} onClick={toggleSearch}></div>

      {/* Top Bar */}
      <div className="top-bar-mobile">
        <div className="navbar-hamburger-mobile" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
          <span className={`hamburger-icon ${isSidebarOpen ? 'active' : ''}`}></span>
        </div>
        <div className="navbar-logo">
          <a className="logo-part-f" href="/">F</a>
          <a className="logo-part-lotec" href="/">LOTEC</a>
        </div>
        <div className="icon-container">
          <div className="navbar-icon-container" onClick={toggleSearch}>
            {isSearchActive ? <FaTimes className="search-icon" /> : <FaSearch className="search-icon" />}
          </div>
          <div className="navbar-call">
            <svg
              className="call-icon"
              focusable="false"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            <span href="tel:3172736919" className="call-number">Call Us at: 317-273-6960</span>
          </div>

          <div className="navbar-icons">
            <div
              ref={userIconRef}
              onClick={() => setIsModalVisible(!isModalVisible)}
              className="navbar-icon-container"
            >
              <FaUserCircle className="navbar-icon" />
              <span className="call-number">Login/Register</span>
            </div>
          </div>

        </div>
      </div>

      <div className={`navbar-mobile ${isSearchActive ? 'search-active' : ''}`}>
        {isSearchActive && <SearchBar setIsSearchActive={setIsSearchActive} />} {/* Only show SearchBar if search is active */}
      </div>


      {/* Main Navbar */}
      <nav className={`navbar ${isSearchActive ? 'search-active' : ''}`}>
        <div className="navbar-container">
          <div className="navbar-logo">
            <a className="logo-part-f" href="/">F</a>
            <a className="logo-part-lotec" href="/">LOTEC</a>
          </div>

          <SearchBar setIsSearchActive={setIsSearchActive} />

          <div className="icon-container">
            {/* Call Button */}
            <a href="tel:3172736979" className="call-button">
              <div className="navbar-call">
                <svg
                  className="call-icon"
                  focusable="false"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span className="call-number">317-273-6960</span>
              </div>
            </a>

            {/* Email Button */}
            <button className="call-button" onClick={() => setIsModalVisible(true)}>
              <div className="navbar-call">
                <svg
                  className="call-icon"
                  focusable="false"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="4" width="20" height="16" rx="2" ry="2" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span className="call-number">orderdesk@floteco2.com</span>
              </div>
            </button>
          </div>
        </div>
      </nav>


      {/* Link Bar */}
      <div className="link-bar">
        <ul className="navbar-links">
          <li><Link to="/" className="navbar-link">Home </Link></li>
          <li><Link to="/about" className="navbar-link">About</Link></li>
          <li><Link to="/products" className="navbar-link">Products</Link></li>
          <li><Link to="/contact" className="navbar-link">Contact</Link></li>
          <li><Link to="/ifu" className="navbar-link">Instructions for use</Link></li>
          <li><Link to="/certs" className="navbar-link">ISO Certification</Link></li>
          <li className="more-links">
            More Links <span className="arrow">▼</span> {/* Small arrow symbol */}
            <div className="more-links-dropdown">
              <Link to="/faq" className="dropdown-link">Frequently Asked Questions</Link>
              <Link to="/offers" className="dropdown-link">Special Offers</Link>
              <Link to="/sitemap" className="dropdown-link">Sitemap</Link>
            </div>
          </li>
        </ul>
      </div>

      {/* Overlay */}
      <div className={`overlay ${isSidebarOpen ? 'open' : ''}`} onClick={() => setIsSidebarOpen(false)}></div>

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <ul className="sidebar-links">
          {/* Container for Main Navigation Links */}
          <div className="sidebar-links-container">
            <li>
              <Link to="/" className="sidebar-link" onClick={() => setIsSidebarOpen(false)}>
                Home <i className="fa fa-chevron-right"></i>
              </Link>
            </li>
            <li>
              <Link to="/about" className="sidebar-link" onClick={() => setIsSidebarOpen(false)}>
                About <i className="fa fa-chevron-right"></i>
              </Link>
            </li>
            <li>
              <Link to="/products" className="sidebar-link" onClick={() => setIsSidebarOpen(false)}>
                Products <i className="fa fa-chevron-right"></i>
              </Link>
            </li>
            <li>
              <Link to="/contact" className="sidebar-link" onClick={() => setIsSidebarOpen(false)}>
                Contact <i className="fa fa-chevron-right"></i>
              </Link>
            </li>
          </div>

          {/* Additional links without dropdown */}
          <li>
            <Link to="/faq" className="sidebar-link" onClick={() => setIsSidebarOpen(false)}>
              Frequently Asked Questions <i className="fa fa-chevron-right"></i>
            </Link>
          </li>
          <li>
            <Link to="/ifu" className="sidebar-link" onClick={() => setIsSidebarOpen(false)}>
              Instructions For Use <i className="fa fa-chevron-right"></i>
            </Link>
          </li>
          <li>
            <Link to="/certs" className="sidebar-link" onClick={() => setIsSidebarOpen(false)}>
              Certificates And Licensing <i className="fa fa-chevron-right"></i>
            </Link>
          </li>
          <li>
            <Link to="/offers" className="sidebar-link" onClick={() => setIsSidebarOpen(false)}>
              Special Offers <i className="fa fa-chevron-right"></i>
            </Link>
          </li>
        </ul>

        {/* Call Now Button */}
        <div className="sidebar-call-button-container">
          <a href="tel:3172736919" className="sidebar-call-button">
            Call Now: 317-273-6979
          </a>
        </div>
      </div>

      {/* ✅ Place this right before closing the fragment */}
      {isModalVisible && <EmailModal onClose={() => setIsModalVisible(false)} />}
    </>
  );
};

export default Navbar;
